import { onApiError } from "../error"
import { del, put } from "./client"

/**
 * @param {string} imei 
 */
async function delFencealarm2(imei) {
    const res = await del(`/fencealarm2s/${imei}`)
    if (!res.ok) throw await onApiError(res)
}

/**
 * @typedef {Object} PutFencealarm2Body
 * @property {PutFencealarm2BodyVoltageAlarm} VoltageAlarm
 * @property {PutDeviceMetadata} Metadata
 * @property {string} Subscription
 * 
 * @typedef {Object} PutFencealarm2BodyVoltageAlarm
 * @property {boolean} Enabled
 * @property {number} Threshold
 * 
 * @typedef {Object} PutDeviceMetadata
 * @property {string[]} Access
 * @property {string[]} Notify
 * @property {string[]} Tags
 * @property {string} Name
 * @property {string} Owner
 * 
 * @param {string} imei 
 * @param {PutFencealarm2Body} body 
 */
async function putFencealarm2(imei, body) {
    const res = await put(`/fencealarm2s/${imei}`, {
        body: JSON.stringify(body),
    })

    if (!res.ok) throw await onApiError(res)
    return res.json()
}

export {
    delFencealarm2,
    putFencealarm2,
}